export enum FeaturedMosaicTextThemes {
  Dark = 'dark',
  Light = 'light',
}
